
<template>
  <el-dialog title="快递单号" :visible="isShow" width="1000px" @close="handleCancel">
    <div>
      <div
        style="max-height: 800px;min-height: 200px;overflow-y: auto"
      >
        <div v-if="Processing.logisticCode" style="margin: 10px 0">
          <span>运单号：{{ Processing.logisticCode }}</span>
        </div>
        <div style="margin-left: 60px">
          <rj-timeline class="Processing">
            <rj-timeline-item
              v-for="(pro, index) in Processing.traces"
              :key="index"
              :color="index != 0 ? '#909399' : ''"
            >
              <p>{{ pro.acceptStation }}</p>
              <p>{{ pro.acceptTime }}</p>
              <div v-if="index == 0" class="itemState">
                {{ $store.state.enumeration.LogisticsStatus[Processing.state] }}
              </div>
            </rj-timeline-item>
          </rj-timeline>
        </div>
        <no-data v-if="!Processing.logisticCode" />
      </div>
    </div>

    <span class="footer-btn">
      <el-button type="default" @click="handleCancel">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import noData from '@/components/noData';
import timeLine from 'rjelement-components/packages/components/timeLine';
import timeLineItem from 'rjelement-components/packages/components/timeLineItem';
import { getLogisticsInfoToList } from '@/API';
import { getIntelLogisticsDetailByFhNum } from '@/API/international';
export default {
  components: {
    noData,
    'rj-timeline': timeLine,
    'rj-timeline-item': timeLineItem
  },

  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    // 时间轴的数据
    formData: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      intelLogisticsInfo: {},
      ProcessingLoading: false,
      Processing: {}
      // Processing: { 'shipperCode': '', 'logisticCode': 'JDVC06786359848', 'success': true, 'reason': '', 'state': 4, 'traces': [{ 'acceptTime': '2021-01-07 20:14:42', 'acceptStation': '您的快件已签收，感谢您使用京东物流，期待再次为您服务。', 'remark': '' }, { 'acceptTime': '2021-01-07 09:21:51', 'acceptStation': '您的快件由【天津武清转运中心】准备发往【天津城配车队】', 'remark': '' }, { 'acceptTime': '2021-01-07 09:21:46', 'acceptStation': '您的快件在【天津武清转运中心】分拣完成', 'remark': '' }, { 'acceptTime': '2021-01-07 08:54:21', 'acceptStation': '【天津货嘀嘀物联科技有限公司】您的快件正在派送中，请您准备签收（快递员：货嘀嘀解明辉，联系电话：15822241557）', 'remark': '' }, { 'acceptTime': '2021-01-06 15:25:28', 'acceptStation': '您的快件已到达【天津武清转运中心】', 'remark': '' }, { 'acceptTime': '2021-01-05 05:50:54', 'acceptStation': '您的快件已发车', 'remark': '' }, { 'acceptTime': '2021-01-05 04:00:17', 'acceptStation': '您的快件由【泉州转运中心】准备发往【天津武清转运中心】', 'remark': '' }, { 'acceptTime': '2021-01-05 04:00:12', 'acceptStation': '您的快件在【泉州转运中心】分拣完成', 'remark': '' }, { 'acceptTime': '2021-01-05 03:11:50', 'acceptStation': '您的快件已到达【泉州转运中心】', 'remark': '' }, { 'acceptTime': '2021-01-04 22:38:37', 'acceptStation': '您的快件已发车', 'remark': '' }, { 'acceptTime': '2021-01-04 22:38:32', 'acceptStation': '快递司机收箱', 'remark': '' }, { 'acceptTime': '2021-01-04 19:34:35', 'acceptStation': '您的快件已到达【福州锐捷B驻场】', 'remark': '' }, { 'acceptTime': '2021-01-04 19:34:34', 'acceptStation': '您的快件已由【福州锐捷B驻场】揽收完成', 'remark': '' }, { 'acceptTime': '2021-01-04 19:34:34', 'acceptStation': '京东快递 已收取快件', 'remark': '' }] }
    };
  },

  methods: {
    initData (val, invoiceNumber) {
      if (val) {
        this.Processing = {
          traces: []
        };
        getLogisticsInfoToList(val).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.Processing = json.data;
          }
        }).catch((e) => {
          console.log(e);
        });
      }
      if (invoiceNumber) {
        this.intelLogisticsInfo = {
        };
        getIntelLogisticsDetailByFhNum(invoiceNumber).then((res) => {
          let json = res.data;
          if (json.status === '200' && json.data !== null) {
            this.intelLogisticsInfo = json.data;
          }
        }).catch((e) => {
          console.log(e);
        });
      }
    },

    handleCancel () {
      this.$emit('handle-cancel');
    }
  }
};
</script>

<style scoped>
.footer-btn{
  display: flex;
  justify-content: flex-end;
}
</style>
